module.exports = __webpack_public_path__ + "img/pc-1.b2d93cbe.svg";